/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Dialog_DescriptionInputs */

const en_clients_create_dialog_description = /** @type {(inputs: Clients_Create_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose person or company, then fill in the details. Check 'Attach contract' to register as an Active client.`)
};

const pt_br2_clients_create_dialog_description = /** @type {(inputs: Clients_Create_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pessoa ou empresa e preencha os dados. Marque 'Anexar contrato' para cadastrar como Cliente Ativo.`)
};

/**
* | output |
* | --- |
* | "Choose person or company, then fill in the details. Check 'Attach contract' to register as an Active client." |
*
* @param {Clients_Create_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_dialog_description = /** @type {((inputs?: Clients_Create_Dialog_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Dialog_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_dialog_description(inputs)
	return pt_br2_clients_create_dialog_description(inputs)
});